<template>
  <div class="detail-row-wrapper">

    <div class="detail-row-component-wrapper"
         :style="{ flexDirection: outerVertical ? 'column' : 'row' }">

      <p class="header"
         v-if="!outerVertical">
        {{ title }}
      </p>

      <div class="inner-wrapper"
           :style="{ flexDirection: (innerVertical ? 'column' : 'row') }">

        <slot>
          아무것도 없습니다.
        </slot>
      </div>

    </div>

    <div v-if="!disableLine" class="line"></div>

  </div>
</template>

<script>
export default {
  name: 'DetailRowComponent',
  props: {
    title: String,
    outerVertical: {
      type: Boolean,
      default: false,
    },
    innerVertical: {
      type: Boolean,
      default: false,
    },
    disableLine: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-row-wrapper {
  width: 100%;

  .detail-row-component-wrapper {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;

    padding-top: 15px;
    padding-bottom: 15px;

    padding-left: 10px;

    .header {
      width: 200px;

      margin: 0;
    }

    .header-column {
      padding-bottom: 20px;
    }

    .inner-wrapper {
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;

      margin: 0;
    }
  }

  .line {
    width: 100%;
    border: rgba(0, 0, 0, 0.04) 1px solid;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/detail-row/DetailRowComponent.vue